import { StyleSheet } from 'aphrodite';
import { borderColor, white } from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		minHeight: '100vh',
		padding: '10px', // Equal padding on all sides for consistent gray border
		boxSizing: 'border-box',
		background: white, // White background to match footer
	},

	surveyContent: {
		maxWidth: '500px',
		margin: '0 auto 20px auto', // Added 20px bottom margin for footer buffer
		padding: '60px 30px 40px 30px', // Added extra 20px top padding
		borderRadius: '12px',
		boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
		border: `1px solid ${borderColor}`,
	},

	header: {
		height: 0,
		margin: 0,
		padding: 0,
		overflow: 'hidden',
	},

	footer: {
		height: 0,
		margin: 0,
		padding: 0,
		overflow: 'hidden',
	},
});
